import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from "react-router-dom";
import DataTable from 'react-data-table-component';
import moment from 'moment';
import ReportsV2 from '../Services/ReportsV2';
import Alert from '../Services/Alert';
import { getDateFormat } from '../Services/Custom';

const CURRENCY = process.env.REACT_APP_CURRENCY_SYMBOL || '₹';
const money = (v) => `${CURRENCY}${Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Read-only list of soft-deleted accounts, with the balances still sitting on them. */
export const DeletedUsersReport = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const [searchFromDate, setSearchFromDate] = useState('');
    const [searchToDate, setSearchToDate] = useState('');
    const [isReset, setIsReset] = useState(false);

    const dflt = { users: 0, wallet: 0, wallet_wining: 0, wallet_bonus: 0, grand_total: 0 };
    const [summary, setSummary] = useState(dflt);

    const columns = useMemo(() => [
        { name: 'Deleted on', selector: row => (row.deletedAt ? moment(row.deletedAt).format('DD-MM-YYYY hh:mm A') : '-'), width: '175px' },
        { name: 'Mobile', selector: row => row.mobile_no || '-', width: '140px' },
        { name: 'Name', selector: row => [row.firstname, row.lastname].filter(Boolean).join(' ') || '-', wrap: true },
        { name: 'Joined', selector: row => (row.createdAt ? moment(row.createdAt).format('DD-MM-YYYY') : '-'), width: '120px' },
        { name: 'Wallet', selector: row => money(row.wallet), right: true },
        { name: 'Winning', selector: row => money(row.wallet_wining), right: true },
        { name: 'Bonus', selector: row => money(row.wallet_bonus), right: true },
    ], []);

    function fetchReport(page, size = perPage) {
        setLoading(true);
        ReportsV2.deletedUsers({ page, size, search, searchFromDate, searchToDate }).then(resp => {
            const r = resp.data;
            if (r.status == 1) {
                setData(r.data.docs);
                setTotalRows(r.total);
                if (page === 1) setSummary(r.summaryData || dflt);
            } else Alert.error(r.message);
            setLoading(false);
        }).catch(err => { setLoading(false); Alert.error(err.message); });
    }

    useEffect(() => { fetchReport(1); }, [isReset]);

    return (
        <section className="main-content marketadd_main_sec">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title mb-1">Deleted Users</h4>
                                    <p className="text-muted">
                                        Accounts that have been deleted. Balances shown are what remained on the
                                        account at deletion and are not counted in the Users Balance report.
                                    </p>

                                    <div className="table-responsive mb-4">
                                        <table className="table align-middle table-nowrap mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Deleted accounts</th>
                                                    <th className="text-end">Wallet</th>
                                                    <th className="text-end">Winning</th>
                                                    <th className="text-end">Bonus</th>
                                                    <th className="text-end">Total held</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><span className="badge bg-danger">{summary.users}</span></td>
                                                    <td className="text-end">{money(summary.wallet)}</td>
                                                    <td className="text-end">{money(summary.wallet_wining)}</td>
                                                    <td className="text-end">{money(summary.wallet_bonus)}</td>
                                                    <td className="text-end">{money(summary.grand_total)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="border border-primary p-3 mb-4">
                                        <div className="row">
                                            <div className="col-lg-2">
                                                <label className="form-label">Deleted from</label>
                                                <input type="date" className="form-control" max={getDateFormat()}
                                                    value={searchFromDate} onChange={e => setSearchFromDate(e.target.value)} />
                                            </div>
                                            <div className="col-lg-2">
                                                <label className="form-label">To</label>
                                                <input type="date" className="form-control" max={getDateFormat()} min={searchFromDate}
                                                    value={searchToDate} onChange={e => setSearchToDate(e.target.value)} />
                                            </div>
                                            <div className="col-lg-4">
                                                <label className="form-label">Search (mobile, name or email)</label>
                                                <input type="text" className="form-control" value={search}
                                                    onChange={e => setSearch(e.target.value)}
                                                    onKeyDown={e => { if (e.key === 'Enter') setIsReset(!isReset); }} />
                                            </div>
                                            <div className="col-lg-4 d-flex align-items-end">
                                                <button className="btn btn-primary me-2" onClick={() => setIsReset(!isReset)}>Filter</button>
                                                <button className="btn btn-light" onClick={() => { setSearch(''); setSearchFromDate(''); setSearchToDate(''); setIsReset(!isReset); }}>Reset</button>
                                            </div>
                                        </div>
                                    </div>

                                    <DataTable
                                        columns={columns} data={data} progressPending={loading}
                                        pagination paginationServer paginationTotalRows={totalRows}
                                        onChangeRowsPerPage={(n, p) => { setPerPage(n); fetchReport(p, n); }}
                                        onChangePage={(p) => fetchReport(p)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default withRouter(DeletedUsersReport);
